import { getCookieConsent } from 'providers/CookieConsentProvider';

const REGIONS_DENY_DEFAULT = [
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',
  'GB',
  'US-CA',
];

function init() {
  console.log('[Bing] init started');

  const tagId = '56382074';

  const scriptElement = document.createElement('script');
  scriptElement.innerHTML = `(function(w,d,t,r,u){var f,n,i;w[u]=w[u]||[],f=function(){var o={ti:"${tagId}", enableAutoSpaTracking: true};o.q=w[u],w[u]=new UET(o),w[u].push("pageLoad")},n=d.createElement(t),n.src=r,n.async=1,n.onload=n.onreadystatechange=function(){var s=this.readyState;s&&s!=="loaded"&&s!=="complete"||(f(),n.onload=n.onreadystatechange=null)},i=d.getElementsByTagName(t)[0],i.parentNode.insertBefore(n,i)})(window,document,"script","//bat.bing.com/bat.js","uetq");`;
  scriptElement.async = true;
  document.head.appendChild(scriptElement);

  const cookieConsent = getCookieConsent();

  const advertisementCookie = cookieConsent.advertisement;
  const personalizationCookie = cookieConsent.personalised_ads;
  const analyticsCookie = cookieConsent.analytics;

  const updateObject = Object.assign({});
  if (advertisementCookie && personalizationCookie) {
    updateObject.ad_storage =
      advertisementCookie === true || personalizationCookie === true
        ? 'granted'
        : 'denied';
  }

  if (analyticsCookie) {
    updateObject.analytics_storage =
      analyticsCookie === true ? 'granted' : 'denied';
  }

  if (advertisementCookie) {
    updateObject.ad_user_data =
      advertisementCookie === true ? 'granted' : 'denied';
  }

  if (personalizationCookie) {
    updateObject.ad_personalization =
      personalizationCookie === true ? 'granted' : 'denied';
  }

  const bingAdsSetupScriptElement = document.createElement('script');
  bingAdsSetupScriptElement.innerHTML = `
      window.uetq = window.uetq || [];
      
      window.uetq.push('consent', 'default', {
        'analytics_storage': 'denied',
        'ad_storage': 'denied',
        'ad_user_data': 'denied',
        'ad_personalization': 'denied',
        'region': ${JSON.stringify(REGIONS_DENY_DEFAULT)},
      });  
      window.uetq.push('consent', 'default', {
        'analytics_storage': 'granted',
        'ad_storage': 'granted',
        'ad_user_data': 'granted',
        'ad_personalization': 'granted',
      });
      window.uetq.push('consent', 'update', ${JSON.stringify(updateObject)});
  `;
  document.head.appendChild(bingAdsSetupScriptElement);
}

export default {
  init,
};
